import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './payment-option-card.css'

const PaymentOptionCard = (props) => {
  return (
    <div className={`payment-option-card-service-card ${props.rootClassName} `}>
      <img
        alt={props.imageAlt}
        src={props.imageSrc}
        className="payment-option-card-image"
      />
      <div className="payment-option-card-container">
        <span className="payment-option-card-heading service-card-title">
          {props.heading ?? (
            <Fragment>
              <span className="payment-option-card-text1">
                <span>
                  Credit Card Payment
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>via the App</span>
              </span>
            </Fragment>
          )}
        </span>
      </div>
    </div>
  )
}

PaymentOptionCard.defaultProps = {
  rootClassName: '',
  imageSrc: '/wu%20element.svg',
  heading: undefined,
  imageAlt: 'image',
}

PaymentOptionCard.propTypes = {
  rootClassName: PropTypes.string,
  imageSrc: PropTypes.string,
  heading: PropTypes.element,
  imageAlt: PropTypes.string,
}

export default PaymentOptionCard
